module.exports = __webpack_public_path__ + "img/cbn.0550e843.jpeg";